import { useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

import { FormField, FormFileDownload, FormSection, Option } from '../../types';
import { useBaseTranslate, useIsI18nRouter } from '../../hooks';

import GridifyItem from './GridifyItem';

interface GridifyProps {
    data: FormSection<any> | FormField<any>[];
    children?: React.ReactNode;
    removeMargin?: boolean;
    selectOptions?: Option[];
    download?: Partial<FormFileDownload>;
}

const Gridify: React.FC<GridifyProps> = ({ data, removeMargin, children, selectOptions, download }) => {
    const classes = useStyles();

    const translate = useBaseTranslate();
    const isI18nRouter = useIsI18nRouter();

    const isMobile = useMediaQuery('(max-width: 800px)');

    const dataToMap = useMemo(() => Array.isArray(data) ? data : data.data, [data]);
    const title = useMemo(() => !isI18nRouter && (data as FormSection).title, [data, isI18nRouter]);

    return (
        <div className={clsx(!removeMargin && 'grid-section', 'gridify')}>
            {title && (
                <div className='grid-title'>
                    {typeof title === "string" ? title : translate(title)}
                </div>
            )}
            <Grid item container direction='row' xs={12} justify="space-between">
                {dataToMap.map((item: FormField) => (
                    <Grid
                        key={item.id}
                        item
                        xs={isMobile ? 12 : 6}
                        className={clsx(classes.gridItem, !isI18nRouter && classes.notRouterGridItem)}
                    >
                        <GridifyItem
                            item={item}
                            download={download}
                            selectOptions={selectOptions}
                        />
                    </Grid>
                ))}
            </Grid>
            {children}
        </div>
    );
}

export default Gridify;

const useStyles = makeStyles(theme => ({
    gridItem: {
        [theme.breakpoints.down(800)]: {
            paddingBottom: 8
        }
    },

    notRouterGridItem: {
        width: '10vw'
    }
}));